module.exports = __webpack_public_path__ + "img/NachdemBaden.e30069e0.jpg";